export default "__VITE_ASSET__B_m072L$__"